import React from "react";

const CostFormCalculationContext = React.createContext({});

export default CostFormCalculationContext;
